import { render } from "./Detail.vue?vue&type=template&id=0ddbf8c8&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=0ddbf8c8&lang=css"
import "./Detail.vue?vue&type=style&index=1&id=0ddbf8c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddbf8c8"]])

export default __exports__